import { firstClickSliderVideoEvents } from "./video-events.js";

export function sliderEvents() {
	const sliders = document.querySelectorAll(".ilawyer-slider");
	const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0;
	// load and initialize the slider if it hasn't been already.
	async function loadSlider(slider) {
		if (!slider.dataset.sliderInitialized) {
			try {
				const sliderModule = await import("./slider.js");
				await sliderModule.initSlider(slider);
				slider.dataset.sliderInitialized = true;
			} catch (err) {
				console.error("Failed to load slider module:", err);
			}
		}
	}
	sliders.forEach((slider) => {
		const nextButton = slider.querySelector('[data-ilawyer-button="next"]');
		const prevButton = slider.querySelector('[data-ilawyer-button="prev"]');
		// Attach pointerdown events on the arrow buttons (fire only once, passive).
		if (nextButton) {
			nextButton.addEventListener(
				"pointerdown",
				async (event) => {
					event.stopPropagation();
					await loadSlider(slider);
					nextButton.click();
				},
				{ once: true, passive: true }
			);
		}
		if (prevButton) {
			prevButton.addEventListener(
				"pointerdown",
				async (event) => {
					event.stopPropagation();
					await loadSlider(slider);
					prevButton.click();
				},
				{ once: true, passive: true }
			);
		}
		// Attach swipe detection on any child element that matches the selectors.
		const tracks = slider.querySelectorAll(".ilawyer-slider-track, .ilawyer-pagination");
		if (tracks.length > 0) {
			tracks.forEach((track) => {
				const swipeState = { initialX: null, initialY: null };
				// Define the touchstart handler.
				const touchStartHandler = (e) => {
					e.stopPropagation();
					swipeState.initialX = e.touches[0].clientX;
					swipeState.initialY = e.touches[0].clientY;
				};
				// Define the touchend handler.
				const touchEndHandler = async (e) => {
					e.stopPropagation();
					if (swipeState.initialX === null || swipeState.initialY === null) return;
					const currentX = e.changedTouches[0].clientX;
					const currentY = e.changedTouches[0].clientY;
					const diffX = swipeState.initialX - currentX;
					const diffY = swipeState.initialY - currentY;
					// Reset swipe state.
					swipeState.initialX = null;
					swipeState.initialY = null;
					const threshold = 30; // Minimum swipe distance in pixels.
					if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > threshold) {
						await loadSlider(slider);
						// Remove the external swipe handlers after loading.
						if (slider.dataset.sliderInitialized) {
							track.removeEventListener("touchstart", touchStartHandler);
							track.removeEventListener("touchend", touchEndHandler);
						}
						// Determine swipe direction and dispatch a custom event.
						const direction = diffX > 0 ? "swipe left" : "swipe right";
						const swipeEvent = new CustomEvent("sliderSwipe", {
							bubbles: true,
							cancelable: true,
							detail: { direction },
						});
						slider.dispatchEvent(swipeEvent);
						// videos in slider
						const slideTrack = e.target.closest(".ilawyer-slider-track");
						const videos = slideTrack.querySelectorAll(".ilawyer-video");
						if (videos) {
							firstClickSliderVideoEvents(videos);
						}
					} else {
						// If the movement isn't considered a swipe (a tap), load the slider
						// and remove external swipe events.
						await loadSlider(slider);
						// videos in slider
						const slideTrack = e.target.closest(".ilawyer-slider-track");
						const videos = slideTrack.querySelectorAll(".ilawyer-video");
						console.log("videos", videos);
						if (videos.length > 0) {
							firstClickSliderVideoEvents(videos, e.target);
						}
						if (slider.dataset.sliderInitialized) {
							track.removeEventListener("touchstart", touchStartHandler);
							track.removeEventListener("touchend", touchEndHandler);
						}
					}
				};
				// Attach the touch events (without once so they fire on each interaction until removed).
				track.addEventListener("touchstart", touchStartHandler, { passive: true });
				track.addEventListener("touchend", touchEndHandler, { passive: true });
			});
		}

		// For non-touch devices, preload the slider on mouseenter (fire only once, passive).
		if (!isTouchDevice) {
			slider.addEventListener(
				"mouseenter",
				(e) => {
					e.stopPropagation();
					loadSlider(slider);
					// videos in slider
					const slideTrack = e.target.querySelector(".ilawyer-slider-track");
					const videos = slideTrack.querySelectorAll(".ilawyer-video");
					if (videos) {
						firstClickSliderVideoEvents(videos);
					}
				},
				{ once: true, passive: true }
			);
		}
	});
}
